export class CookiesHandler {
    /** Method to create token cookie set a deadline of 4 hours
     * @param token (string)
    */
    static createCookie(token) {
        let expireDate = (new Date(Date.now() + 14400 * 1000)).toUTCString();
        document.cookie = 'token=' + token + '; expires=' + expireDate + ';';
    }
    /** Method to get token from token cookies
     * @param cookiesName
     * @return token or empty string
    */
    static getTokenFromCookie(cookieName) {
        var name = cookieName + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    /** Method to delete token cookies
     * @param coockieName
    */
    static deleteCookie(cookieName) {
        document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
}
